import { render, staticRenderFns } from "./ViewNameSkeleton.vue?vue&type=template&id=f002dc8a&scoped=true"
import script from "./ViewNameSkeleton.vue?vue&type=script&lang=js"
export * from "./ViewNameSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ViewNameSkeleton.vue?vue&type=style&index=0&id=f002dc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f002dc8a",
  null
  
)

export default component.exports